import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

const salsify = getServiceProvider('salsify');

export default createServiceProvider({
  ...salsify,
  requiresOAuthFlow: false,
  titleToId: true,
  titleToNamespace: true,
  hasConnectionStatus: true,
  defaultAuthenticationType: 'bearer',
  avatarPath: avatars.salsify,
  logoPath: logos.salsify
});
